<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>assignment</mat-icon>
        </button>
        <span>Vorgang auswählen</span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <mat-form-field class="width" appearance="fill">

            <mat-label>Vorgang suchen</mat-label>
            <input type="text" placeholder='Suchbegriff eingeben' matInput [formControl]="formControl"
                (keyup.enter)="search()" autocomplete="off" />
            <mat-icon matSuffix>search</mat-icon>

        </mat-form-field>

        <div class="results preview-entry-container" *ngIf="issues.length > 0; else noIssues">

            <div class="preview-entry" *ngFor="let issue of issues" (click)="issueClicked(issue)">
                <app-issue-preview [issue]="issue"></app-issue-preview>
            </div>

            <div class="load-more-wrapper" *ngIf="total > issues.length">

                <button mat-raised-button (click)="loadMore()">
                    Mehr laden
                </button>

            </div>

        </div>

        <div class="footer">

            {{issues.length}} von {{total}}

        </div>

    </div>

</div>

<ng-template #noIssues>

    <div class="no-issues-hint">

        <div class="text">Keine Vorgang gefunden</div>

    </div>

</ng-template>
